import React from 'react';
import {compose} from 'react-apollo';

import {Card} from 'ui-kit';

import {DetailRow} from './components';
import * as styles from './ContactDetailsCard.module.css';

function ContactDetailsCard({email, phone}) {
  return (
    <Card>
      <h3 className={styles.Heading}>Contact details</h3>

      <div className={styles.Rows}>
        <DetailRow
          label="Email"
          content={email}
          emptyText="No email provided"
        />
        <DetailRow
          label="Phone number"
          content={phone}
          emptyText="No phone number provided"
        />
      </div>
    </Card>
  );
}

export default compose()(ContactDetailsCard);
